import { useMemo, useState, useEffect, useCallback } from 'react';
import { isPointInPolygon } from 'geolib';

export function usePropertiesInViewport(properties, viewport) {
  let [ hash, setHash ] = useState('');
  let [ viewported, setViewported ] = useState([]);
  let [ highlighted, setHighlighted ] = useState([]);

  useEffect(() => {
    if (!viewport || !properties.length) {
      setViewported([]);
      setHash('');
      return;
    }

    let polygon = [
      { latitude: viewport._northEast.lat, longitude: viewport._northEast.lng },
      { latitude: viewport._northEast.lat, longitude: viewport._southWest.lng },
      { latitude: viewport._southWest.lat, longitude: viewport._southWest.lng },
      { latitude: viewport._southWest.lat, longitude: viewport._northEast.lng },
    ];

    let newViewported = properties.filter(x => isPointInPolygon({ latitude: x.coords[0], longitude: x.coords[1] }, polygon));
    let newHighlighted = highlighted.filter(x => newViewported.some(y => y.id === x.id));

    if (newHighlighted.length !== highlighted.length) {
      setHighlighted(newHighlighted);
    }

    newViewported = newViewported.filter(x => !highlighted.some(y => y.id === x.id));

    let newHash = newViewported.map(x => x.id).join('');

    if (newHash === hash) return;

    setHash(newHash);
    setViewported(newViewported);
  }, [properties, viewport, highlighted]);

  return {
    viewportedProperties: viewported,
    highlightedProperties: highlighted,
    highlightProperties: setHighlighted,
  };
}
